/**
 * streamlines add a dynamic value to height.
 * @param {object} param0
 * @param {string} param0.$height
 * @returns {string}
 */
const dynHeight = ({ $height }) => {
  if ($height === undefined) return "";
  if (typeof $height === "number") return `height: ${$height}px;`;
  return `height: ${$height};`;
};

export default dynHeight;
